import React from 'react';

const TextField = ({ 
  label, 
  id, 
  name, 
  type = 'text', 
  placeholder, 
  value, 
  onChange, 
  required = false, 
  disabled = false,
  className = '',
  dark = false,
  prefixIcon,
  ...props 
}) => {
  const inputClasses = dark ? 'input-field-dark' : 'input-field';
  const hasPrefixIcon = prefixIcon !== undefined && prefixIcon !== null;
  const inputPadding = hasPrefixIcon ? (dark ? 'pl-10' : 'pl-10') : '';
  
  return (
    <div>
      {label && (
        <label htmlFor={id || name} className="block text-sm font-medium text-gray-700 mb-2 text-left">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="relative">
        {hasPrefixIcon && (
          <div className={`absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none`}>
            {React.isValidElement(prefixIcon) ? (
              prefixIcon
            ) : typeof prefixIcon === 'function' ? (
              React.createElement(prefixIcon, { className: `h-5 w-5 ${dark ? 'text-gray-400' : 'text-gray-400'}` })
            ) : (
              prefixIcon
            )}
          </div>
        )}
        <input
          id={id || name}
          name={name}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          disabled={disabled}
          className={`${inputClasses} ${inputPadding} ${className}`}
          {...props}
        />
      </div>
    </div>
  );
};

export default TextField;

